module.exports = __webpack_public_path__ + "static/media/head-phones-off.176f19c9.png";